export function parseCurrencyInput(value) {
  if (value == null || value === "") return null;
  const digits = String(value).replace(/[^\d-]/g, "");
  if (!digits || digits === "-") return null;
  const parsed = Number(digits);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatISK(value, { empty = "—" } = {}) {
  const parsed = parseCurrencyInput(value);
  if (parsed == null) return empty;
  return `${new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(parsed)} kr`;
}

export function formatISKInput(value) {
  const parsed = parseCurrencyInput(value);
  return parsed == null ? "" : formatISK(parsed, { empty: "" });
}